import React, { useEffect, useState, useRef } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime, { set } from 'animejs';
import HomeButton from '../utils/HomeButton';
import { Navigate, useNavigate } from 'react-router-dom';


const audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/mesere_partition.mp3");
const AnimatedLine = ({ audio, isPlaying }) => {
                    const [left, setLeft] = useState(76);

                    useEffect(() => {
                        let rafId;
                        const update = () => {
                            if (audio.duration > 0) {
                                const progress = audio.currentTime / audio.duration;
                                setLeft(76 + progress * 370);
                            }
                            if (isPlaying && !audio.ended) {
                                rafId = requestAnimationFrame(update);
                            }
                        };
                        if (isPlaying) {
                            rafId = requestAnimationFrame(update);
                        }
                        return () => cancelAnimationFrame(rafId);
                    }, [isPlaying, audio]);

                    return (
                        <div
                            style={{
                                position: 'absolute',
                                top: '58px',
                                left: `${left}px`,
                                width: '2px',
                                height: '200px',
                                backgroundColor: 'black',
                                zIndex: 20,
                                transition: 'left 0.05s linear',
                            }}
                        />
                    );
                };
                
const SardaigneMesere = (props) => {
    const navigate = useNavigate();
    
    const handleImageError = (e) => {
        console.error("Error loading image:", e);
        console.log("Attempted path:", process.env.PUBLIC_URL + "/assets/images/sardaigne/mesere/intro_mesere/A-Consonnes-explications.png");
    };
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const imageCount = 21; // Assuming there are 22 images (0 to 21)

    const [currentImageIndexBoard, setCurrentImageIndexBoard] = useState(25);
    const imageCountBoard = 55; // Assuming there are 22 images (0 to 21)

    const [currentImageIndexPartition, setCurrentImageIndexPartition] = useState(1);
    const imageCountPartition = 26; // Assuming there are 22 images (0 to 21)

    const [showBoardImage, setShowBoardImage] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    const [hoveredTurbulences, setHoveredTurbulences] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => {
                if (prevIndex < imageCount - 1) {
                    return prevIndex + 1;
                } else {
                    clearInterval(interval); // Stop the interval when the last image is reached
                    return prevIndex;
                }
            });
        }, 100); // 0.1s delay

        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        if (showBoardImage) {
            // Start the interval for the board images
            setCurrentImageIndexBoard(25); // Reset to the first board image
            const interval = setInterval(() => {
                setCurrentImageIndexBoard((prevIndex) => {
                    if (prevIndex < imageCountBoard - 1) {
                        return prevIndex + 1;
                    } else {
                        clearInterval(interval); // Stop the interval when the last image is reached
                        return prevIndex;
                    }
                });
            }, 100); // 0.1s delay

            return () => clearInterval(interval);
        }
    }, [showBoardImage]);

    useEffect(() => {
        if (!showBoardImage) {
            // Start the reverse interval for the board images
            setCurrentImageIndexBoard(54); // Reset to the last board image
            const interval = setInterval(() => {
                setCurrentImageIndexBoard((Index) => {
                    if (Index > 25) {
                        return Index - 1;
                    } else {
                        clearInterval(interval); // Stop the interval when the first board image is reached
                        return Index;
                    }
                });
            }, 100); // 0.1s delay

            return () => clearInterval(interval);
        }
    }, [showBoardImage]);

    const timesInSeconds = [0,0.1, 0.36, 0.78, 1.18, 1.58, 1.97, 3.2, 3.76, 4.23, 4.61, 5.07, 5.45, 5.81, 6.18, 6.56, 6.95, 7.4,7.78,8.7,9.7,11.2,12.21,13.49,16.33];

    const displayImageAtTime = (time) => {
        // Find the closest time in timesInSeconds that is <= current time
        const index = timesInSeconds.findLastIndex((t) => t <= time);
        if (index !== -1) {
            setCurrentImageIndexPartition(index);
        }
    };

    useEffect(() => {
        if (isPlaying) {
            const interval = setInterval(() => {
                const currentTime = Math.floor(audio.currentTime * 10) / 10; // 0.1s precision
                displayImageAtTime(currentTime);
                if (audio.ended) {
                setIsPlaying(false);
                clearInterval(interval);
            }
            }, 100); // Check every 0.1 second

            return () => clearInterval(interval);
        }
    }, [isPlaying]);
    return (
        <div
            style={{
                backgroundColor: '#606494',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '660px',
                height: '500px',
            }}
        >
            {/* Display image en arrivant sur la page mesere */}
            <img
                src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/intro_mesere/A-Consonnes-explications.png`}
                onError={handleImageError}
                alt={`Sardaigne Mesere A-Consonnes-explications.png`}
                style={{
                    position: 'absolute',
                    top: '10px',
                    left: '0px',
                    zIndex: 1,
                    width: '660px',
                }}
            />
            {currentImageIndex === imageCount - 1 && (
                <div
                    style={{
                        position: 'absolute',
                        top: '210px',
                        left: '350px',
                        zIndex: 3,
                    }}
                >
                    <button
                        style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            color: 'grey',
                            fontSize: '18px',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = 'white';
                            e.target.nextSibling.style.backgroundColor = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = 'grey';
                            e.target.nextSibling.style.backgroundColor = 'grey';
                        }}
                        onClick={() => 
                            {
                            setShowBoardImage(true); 
                            setCurrentImageIndexBoard(25); 
                            }
                        }
                    >
                        &gt; Analyse spectrale
                    </button>
                    <div
                        style={{
                            height: '2px',
                            backgroundColor: 'grey',
                            marginTop: '5px',
                        }}
                    ></div>
                </div>
            )}
            {/* Display Board en cliquant sur le bouton Analyse spectrale */}
            {showBoardImage && (
                <div>
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/intro_mesere/A1-onglet.png`}
                    onError={handleImageError}
                    alt={`Sardaigne Mesere `}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        left: '0px',
                        zIndex: 10,
                        width: '660px',
                    }}
                />
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/intro_mesere/A1-onglet-surbrillance.png`}
                    onError={handleImageError}
                    alt="Sardaigne Mesere A2-onglet"
                    style={{
                        position: 'absolute',
                        top: '10px',
                        left: '0px',
                        zIndex: 10,
                        width: '660px',
                        opacity: 0,
                        transition: 'opacity 0.5s',
                        ...(currentImageIndexBoard >= 30 && currentImageIndexBoard < 50
                            ? { opacity: 1, transition: 'opacity 1s' }
                            : currentImageIndexBoard >= 50
                            ? { opacity: 0, transition: 'opacity 1s' }
                            : {}),
                    }}
                />
                {/* Animated black line that moves with the music */}
                    {isPlaying && (
                        <AnimatedLine audio={audio} isPlaying={isPlaying} />
                    )}
                </div>
            )}
            {/* Ferme le board */}
            {showBoardImage && (
                <button
                    style={{
                        position: 'absolute',
                        top: '153px',
                        left: '25px',
                        zIndex: 12,
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        border: 'none',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                    }}
                    onClick={() => setShowBoardImage(false)}
                ></button>
            )}
            
            {showBoardImage && (
                <button
                    style={{
                        position: 'absolute',
                        top: '85px',
                        left: '530px',
                        zIndex: 12,
                        width: '80px',
                        height: '20px',
                        borderRadius: '50%',
                        border: 'none',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => setHoveredTurbulences(true)}
                    onMouseLeave={() => setHoveredTurbulences(false)}
                ></button>
            )}
            {hoveredTurbulences && (
                <div>
                    <img
                        src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/intro_mesere/A1-onglet-surbrillance.png`}
                        onError={handleImageError}
                        alt="Sardaigne Mesere A2-onglet"
                        style={{
                            position: 'absolute',
                            top: '10px',
                            left: '0px',
                            zIndex: 10,
                            width: '660px',
                            opacity: 0.2,
                            animation: 'fadeInOut 2s forwards',
                        }}
                    />
                    
                    {/* Animation keyframes */}
                    <style>
                        {`
                        @keyframes fadeInOut {
                            0% { opacity: 0.2; }
                            40% { opacity: 1; }
                            60% { opacity: 1; }
                            100% { opacity: 0.2; }
                        }
                        `}
                    </style>
                </div>
            )}
            {/* Lance les notes de musiques */}
            {isPlaying && (
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/partition_mesere/A-Consonnes-rouge${currentImageIndexPartition}.png`}
                    onError={handleImageError}
                    alt={`Sardaigne Partition Mesere ${currentImageIndexPartition}`}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        left: '0px',
                        zIndex: 5,
                        width: '660px',
                    }}
                />
            )}
            {/* Aller a l'écran voyelles */}
            {(<div
                    style={{
                        position: 'absolute',
                        top: '460px',
                        left: '470px',
                        zIndex: 3,
                    }}
                >
                    <button
                        style={{
                            backgroundColor: 'transparent',
                            border: 'none',
                            color: 'grey',
                            fontSize: '18px',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.color = 'white';
                            e.target.nextSibling.style.backgroundColor = 'white';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.color = 'grey';
                            e.target.nextSibling.style.backgroundColor = 'grey';
                        }}
                        onClick={() => 
                            {
                            window.parent.location.href = 'https://digitaljazz.fr/clesdecoute/'+'sardaigne/voyelles/'
                            
                             //navigate(process.env.PUBLIC_URL + '/sardaigne/8-voyelles/');
                            }
                        }
                    >
                        &gt; Voyelles
                    </button>
                    <div
                        style={{
                            height: '2px',
                            backgroundColor: 'grey',
                            marginTop: '5px',
                        }}
                    ></div>
                </div>
            )}

            {/* Play and Pause Buttons */}
            <button
                style={{
                    position: 'absolute',
                    top: '406px',
                    left: '115px',
                    zIndex: 6,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                }}
                onClick={() => {
                    if (!isPlaying) {
                        audio.play();
                        setIsPlaying(true);
                    }

                }}
            >
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/play.png`}
                    alt="Play Button"
                    style={{ width: '40px', height: '40px' }}
                />
            </button>
            <button
                style={{
                    position: 'absolute',
                    top: '406px',
                    left: '140px',
                    zIndex: 6,
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                }}
                onClick={() => {
                    if (isPlaying) {
                        audio.pause();
                        audio.currentTime = 0;
                        setIsPlaying(false);
                    }
                }}
            >
                <img
                    src={`${process.env.PUBLIC_URL}/assets/images/sardaigne/pause.png`}
                    alt="Pause Button"
                    style={{ width: '40px', height: '40px' }}
                />
            </button>
        </div>
    );
} 
export default SardaigneMesere;